
export const NotFoundPage = () => {
    return (
        <div className="centered-page">
            <h1>404</h1>
            <h1>Page not found!</h1>
        </div>
    );
}